export const environment = {
  production: false,
  graphqlUrl: 'https://staging.kdm.api.innovax.cl/graphql', // URL base para consultar la API de GraphQL
  apiUrl: 'https://staging.kdm.api.innovax.cl/api', // URL base para la API de almacenamiento
  pusher: {
    key : 'ac1cbe2a16b12749fe33',
    cluster : 'us2'
  },
  firebase: {
    apiKey: "AIzaSyDEkibPTcIv6VdPSYmQPTG9wSm8u099tms",
    authDomain: "kdm-pwa.firebaseapp.com",
    projectId: "kdm-pwa",
    storageBucket: "kdm-pwa.firebasestorage.app",
    messagingSenderId: "466846155800",
    appId: "1:466846155800:web:3b12dc92348d96e9506f6d",
    measurementId: "G-HJGX25523D",
    vapidKey: "BOd5uDVV1KUHrvZooDpZoJ3X7ZwVE1a5OBCovRig_RAfPzLIo5VuPcerVlZJKQBChc_na2aHYOc_HEnT2MyGYnI"
  }
  //test: rebuild test jenkins double push
};